<template>
	<footer :class="isFixed?'myfoot':''">
		<div class="text-center">
				<span>Copyright<span style="padding: 0 5px;">&copy;</span>{{startYear}}-{{endYear}}</span>
				<a href="http://szyize.cn" target="_blank">{{company}} </a>
				<span>版权所有reserved</span>
		</div>
	</footer>
</template>

<script>
	export default {
	  name: 'Foot',
	  computed: {

	  },
	  props: {
	    isFixed: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data() {
	    return {
	      startYear: '2017',
	      endYear: new Date().getFullYear(),
	      company: '深圳市艺泽信息技术有限公司'
	    }
	  },
	  methods: {

	  }
	}
</script>

<style scoped>
	footer {
		font-size: 14px;
		background: #fff;
		padding: 10px;
		border-top: 1px solid #d2d6de;
		height: 40px;
	}
	
	a {
		color: #3c8dbc
	}
	
	.myfoot {
		background-color: transparent;
		color: #FBFDFF;
		border-top: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/Footer/index.vue